import { User } from './../../shared/model/user';
import { Component, OnInit } from '@angular/core';
import { InstitutionsService } from '../../shared/services/institutions.service';
import { FormGroup } from '@angular/forms';
import { Institution, IUsers, UserRights } from '../../shared/model/institution';
import { SaveService } from '../../shared/services/save.service';
import { Router } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { AuthService } from '../../shared/security/auth.service';

@Component({
  selector: 'user-update',
  templateUrl: './user-update.component.html',
  styleUrls: ['./user-update.component.css']
})
export class UserUpdateComponent implements OnInit {

  invalidUserType: boolean;
  emailAlreadyInUse: boolean;
  weekPassword: boolean;
  operationNotAllowed: boolean;
  invalidEmail: boolean;
  form: FormGroup;
  user: User;

  constructor(private usersService: UserService,
    private authService: AuthService,
    private saveService: SaveService,
    private institutionService: InstitutionsService,
    private router: Router) { }

  ngOnInit() {
    this.user = this.saveService.getUser();
    this.saveService.setTitle(`Modifier ${this.user.firstName} ${this.user.lastName}`);
  }

  onOutForm(form: FormGroup) {
    this.form = form;
  }

  onSubmit = () => {
    if (this.form.valid) {
      this.save();
    }
  }

  onCancel = () => {
    if (this.user.userType === "ADMIN") {
      this.router.navigate(['responsible-dashboard']);
    } else if (this.user.userType === "NORMAL") {
      console.log("avant student-dashboard dans onCancel")
      this.router.navigate(['student-dashboard']);
    } else {
      this.authService.logout();
      this.saveService.setUser(null);
      this.router.navigate(['login']);
    }
  }

  formatUser(value): User {
    const email = (this.user.userType === 'TEMPO' ? value.emailGroup.email : this.user.email)
    const userType = (value.userType === "1" ? "ADMIN" : "NORMAL");
    return new User("",
      userType,
      value.firstName,
      value.lastName,
      value.address,
      value.city,
      value.prov,
      value.country,
      value.postalCode,
      value.phoneHouse,
      value.phoneMobile,
      value.phoneWork,
      value.phoneExt,
      email,
      value.notifyBySms,
      value.notifyByEmail,
      value.notifyByPhone,
      value.notifyByPush,
      this.user.favoriteInstitution)
  }

  save = () => {

    if (this.user.userType === "TEMPO") {
      this.authService.signUp(this.form.value.emailGroup.email, this.form.value.passwordGroup.password)
        .subscribe(
        val => {
          console.info(`New auth user creates ${val.uid}`)
          this.saveUser(val.uid)
        },
        err => this.handleError(err.code)
        );
    } else {
      this.saveUser(this.user.$key)
    }

  }

  saveUser(userId: string) {

    var newUser: User = this.formatUser(this.form.value);

    this.usersService.saveUser(userId, newUser)
      .subscribe(() => {

        console.info(`User saved ${userId}`);

        this.usersService.deleteUser(this.saveService.getUserId())
          .subscribe((res) => {
            console.info(`User delete ${this.saveService.getUserId()}`);

            newUser.$key = userId;
            this.saveService.setUser(newUser);
            
            if (this.user.userType === "TEMPO") {
              this.updateInstitution();
            } else if (this.user.userType === "NORMAL") {
              this.router.navigate(['student-dashboard'])
            } else {
              this.router.navigate(['responsible-dashboard'])
            }
          });

      },
      err => console.error(`error saving user ${userId} Error = ${err}`)
      );

  }

  handleError(error) {
    if (error == "auth/email-already-in-use") {
      this.emailAlreadyInUse = true
    } else if (error == "auth/invalid-email") {
      this.invalidEmail = true
    } else if (error == "auth/operation-not-allowed") {
      this.operationNotAllowed = true
    } else if (error == "auth/weak-password") {
      this.weekPassword = true
    }

  }

  updateInstitution = () => {
    // Find the institution related to the temporary admin user we just update
    // favoriteInstitution[0] contain info only
    // favoriteInstitution[1] contain the related institution id
    const relatedInstitutionId = this.user.favoriteInstitution[1].institution
    this.institutionService.findInstitutionById(relatedInstitutionId)
      .subscribe((institution) => {
        institution.users[0].user = this.form.value.emailGroup.email;
        institution.users[0].userId = this.saveService.getUserId();
        institution.users[0].rights = "ADMIN";
        institution.contactEmail = this.form.value.emailGroup.email;
        institution.contactPhone = this.form.value.phoneWork;
        institution.contactPhoneExt = this.form.value.phoneExt;

        console.info(`Institution found ${relatedInstitutionId}`);

        this.institutionService.saveInstitution(relatedInstitutionId, institution)
          .subscribe(
          () => {
            console.info(`Institution saved ${relatedInstitutionId}`);
            this.router.navigate(['responsible-dashboard']);
          },
          err => console.error(`Error creating institution ${relatedInstitutionId} Error = ${err}`)
          );

      }),
      err => console.error(`Error finding institution ${relatedInstitutionId} Error = ${err}`);
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/users/user-update/user-update.component.ts